import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {SelectField} from "@/components/form/fields/SelectField/SelectField.tsx";
import {SwitchField} from "@/components/form/fields/SwitchField.tsx";
import {RequiredFieldsNote} from "@/components/form/requiredFieldsNote/RequiredFieldsNote.tsx";
import {DashboardDefinition} from "@/lib/types/website.ts";

interface DashboardFormGeneralProps {
  dashboardDefs: DashboardDefinition[];
}

export const DashboardFormGeneral = ({dashboardDefs}: DashboardFormGeneralProps) => {
  return (
    <div className="d-flex flex-column gap-4" id={"dashboardFormGeneral"}>
      <RequiredFieldsNote spacing={"none"} />
      <div className="d-flex gap-4">
        <div className="w-100">
          <InputField name={"name"} label={"Name"} required={true} tooltip="Displayed name for this Dashboard" />
        </div>

        <div className="w-100">
          <SelectField
            name="dashboard_position"
            label="Menu Position"
            options={dashboardDefs
              .map((_, index) => ({label: (index + 1).toString(), value: index}))
              .concat([{label: "Last", value: dashboardDefs.length}])}
            tooltip="Number of Check Cards to show in the Checks section"
            menuPortalTarget={
              (document.querySelector(`div.outlet-container > div.content-container`) as HTMLElement) ?? document.body
            }
            menuPosition={"fixed"}
          />
        </div>
      </div>

      <SwitchField name="is_pinned" label="Pin this Dashboard to the sidebar for quick access" variant="card" />
    </div>
  );
};
